import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import website from '@/components/website'
import copyTradeIndex from '@/components/website/copy-trade/main'

// =============== /user =======================

import home from '@/components/website/user/home'
import scripDetail from '@/components/website/user/scrip-detail'
import multiView from '@/components/website/multi-view/multi-view'
import gridView from '@/components/website/grid-view/grid-view'
import customView from '@/components/website/user/custom-view'
import portfolioBalance from '@/components/website/user/portfolio-balance'
import full_chart from '@/components/website/shared/advance-chart'
import full_chart_iq from '@/components/website/shared/chart-iq'
import copy_trade from '@/components/website/copy-trade/index'
import leader_detail from '@/components/website/copy-trade/leader-detail'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'home', component: home },
        { path: '/scrip-detail', name: 'scrip-detail', component: scripDetail },
        { path: '/multi-view', name: 'multi-view', component: multiView },
        { path: '/grid-view', name: 'grid-view', component: gridView },
        { path: '/custom-view', name: 'custom-view', component: customView },
        { path: '/portfolio-balance', name: 'portfolio-balance', component: portfolioBalance },
        { path: '/chart', name: 'chart', component: full_chart },
        { path: '/chart-iq', name: 'chart-iq', component: full_chart_iq },
        {
            path : '',
            name:'copyTradeIndex',
            component : copyTradeIndex,
            children : [
                { path: '/leaders', name: 'leaders', component: copy_trade },
                { path: '/leader-detail', name: 'leader-detail', component: leader_detail },
            ]
        },
        { path: '*', redirect : "/" },

        /*{
            path: '/',
            component: website,
            children: [
                { path: '/home', name: 'home', component: home },
            ]
        }*/
    ]
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    let userStateVariable = store.state.user
    if (userStateVariable == '') { userStateVariable = {} }

    else next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js